module.exports = __webpack_public_path__ + "static/UAdeskSlide2-3f79b78ede7f01ba5f1feda5c619e4b3.png";